import { onboardingOverviewSchema } from "../schema";

import { getApiClient } from "@src/api";
import { graphql } from "@src/gql/gql";
import type { StepsFilter } from "@src/gql/graphql";
import {
	queryOptions,
	useQuery,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { onboardingQueryKeys } from "./query-keys";

const getOnboardingStatusQuery = graphql(/* GraphQL */ `
	query GetOnboardingStatus($steps: StepsFilter) {
		users {
			onboarding {
				overview(steps: $steps) {
					createdAt
					id
					position
					streamPosition
					updatedAt
					steps {
						isCompleted
						step
						updatedAt
					}
				}
			}
		}
	}
`);

async function getOnboardingStatus(steps?: StepsFilter) {
	const client = getApiClient();
	const response = await client.query({
		query: getOnboardingStatusQuery,
		variables: { steps },
	});

	const overview = response.data.users.onboarding.overview;
	return overview ? onboardingOverviewSchema.parse(overview) : null;
}

export const getOnboardingStatusQueryOptions = (filter: StepsFilter) =>
	queryOptions({
		queryKey: onboardingQueryKeys.filter(filter),
		queryFn: async () => getOnboardingStatus(filter),
		staleTime: 5 * 60 * 1000, // 5 minutes
	});

export function useGetOnboardingStatusQuery(filter: StepsFilter) {
	return useQuery(getOnboardingStatusQueryOptions(filter));
}

export function useGetOnboardingStatus(filter: StepsFilter) {
	return useSuspenseQuery(getOnboardingStatusQueryOptions(filter));
}
